<template>
  <div @click="forwardZoomEvent(image)" class="combined-image text-center">
    <img src="@/img/lupe.svg" style="background:white;position: absolute; left: 0; top: 0; max-width: 25%" alt="zoom"/>
    <img v-if="image" :src="image" class="img-responsive" alt="" :width="width" :height="height">
    <i v-else class="fa-4x fas fa-image"></i>
  </div>
</template>

<script>
import forwardEvents from '@/mixins/forwardEvents.js'
import System from '@/_system.js'

export default {
  name: 'CombinedImage',
  mixins: [forwardEvents],
  props: {
    filename: Number | String,
    userId: String,
    zoomable: Boolean,
  },
  data () {
    return {
      image: '',
      imageBlob: null,
      width: 800,
      height: 533,
    }
  },
  methods: {
    processImage () {
      this.$emit('process-img', this.userId, this.filename, imageData => {
        this.image = imageData
      })
    },
  },
  async mounted () {
    if (typeof this.filename === 'string' && this.filename.startsWith('data:')) {
      this.image = this.filename
      return;
    }

    const img = new Image()
    img.onload = () => {
      this.image = img.src
      this.width = img.naturalWidth
      this.height = img.naturalHeight
    }
    img.onerror = () => {
      this.processImage()
    }

    try {
      const { data } = await System.readFile(`${this.userId}-${this.filename}.dat`)

      if (data) {
        //reload Image from Cache
        img.src = 'data:image/png;base64,' + data
      } else {
        //download Image
        this.processImage()
      }
    } catch (err) {
      this.processImage()
    }
  },
}
</script>
